import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import $ from 'jquery';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';

import {
  hideIntercomWidget,
  showIntercomWidget,
} from '../helpers';
import {
  userCan,
} from '../helpers/Auth';
import {
  usePageId,
} from '../helpers/PageIdContext';

const ActionbarPageActions = ({
  intl,
  share,
  filesTotal,
  selectedFiles,
  selectedAllFiles,
  selectedCollections,
  selectedAllCollections,
  reorderingMode,
  handleDownload,
}) => {
  const pageId = usePageId();

  useEffect(() => {
    const moreElements = $('.actionbar .action-more .dropdown-menu button').length;
    if (moreElements > 0) {
      $('.actionbar .action-more').removeClass('hidden');
    } else {
      $('.actionbar .action-more').addClass('hidden');
    }

    if (!share) {
      return;
    }

    if (selectedCollections.length === 0 && selectedFiles.length === 0) {
      showIntercomWidget();
    } else {
      hideIntercomWidget();
    }
  });

  if (reorderingMode) {
    return null;
  }

  const lockSelectedAllFilesAction = (
    (selectedAllFiles && selectedFiles.length !== filesTotal) ||
    selectedAllCollections
  );

  const showDownloadButton = (
    selectedFiles.some(file => userCan('file.download', file)) ||
    selectedCollections.some(collection => userCan('collection.download', collection))
  );

  return (
    <Nav className="ml-auto" navbar>
      {showDownloadButton && (
        <NavItem>
          <NavLink
            id="ABDownload"
            href="#download"
            onClick={(e) => {
              e.preventDefault();
              handleDownload(selectedCollections, selectedFiles, pageId);
            }}
            disabled={lockSelectedAllFilesAction}
          >
            <i className="far fa-download" />
          </NavLink>
          <UncontrolledTooltip fade={false} placement="top" target="ABDownload">
            {lockSelectedAllFilesAction ?
              intl.formatMessage({ defaultMessage: 'Load all files to download' }) :
              intl.formatMessage({ defaultMessage: 'Download' })}
          </UncontrolledTooltip>
        </NavItem>
      )}
    </Nav>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  share: state.Shares.share,
  files: state.Files.files,
  filesTotal: state.Files.filesTotal,
  selectedFiles: state.Files.selectedFiles,
  selectedAllFiles: state.Files.selectedAllFiles,
  collectionsTotal: state.Collections.collectionsTotal,
  selectedCollections: state.Collections.selectedCollections,
  selectedAllCollections: state.Collections.selectedAllCollections,
  collection: state.Collections.collection,
  sidebarCollection: state.Collections.sidebarCollection,
  reorderingMode: state.Files.reorderingMode,
  collectionMoveModal: state.Collections.moveModalOpen,
});

const mapDispatchToProps = dispatch => ({
  handleDownload: (collections, files, pageId) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files,
      collections,
      // fileCollectionMap: collectionProp?.uuid ? {
      //   [targetFile.uuid]: [collectionProp.uuid],
      // } : {},
      pageId,
      backdrop: true,
    }));
  },
});

ActionbarPageActions.propTypes = {
  intl: PropTypes.object.isRequired,
  share: PropTypes.object,
  filesTotal: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedAllFiles: PropTypes.bool.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  selectedAllCollections: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
};

ActionbarPageActions.defaultProps = {
  share: null,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActionbarPageActions));
